import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';
import { diagnostics } from '@/utils/diagnostics';

import { useHouseholdWorkflowTrackersContext } from '../contexts';

/**
 * Hook to determine if a household has any active integration cache sync workflow trackers in the
 * current user's workflow trackers.
 *
 * @param householdId
 */
export function useDoesHouseholdHaveActiveEmoneyCacheSync(householdId: string) {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  const activeWorkflowTrackers = trackers.filter((tracker) => {
    if (tracker.status !== WorkflowTrackerStatus.Started) {
      return false;
    }
    if (tracker.kind !== WorkflowTrackerKind.EmoneyCacheSync) {
      return false;
    }
    return tracker.household?.id === householdId;
  });

  if (activeWorkflowTrackers.length > 0) {
    diagnostics.debug('Found activeWorkflowTrackers', {
      activeWorkflowTrackers,
    });
  }

  return activeWorkflowTrackers.length > 0;
}
